<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";

export default {
  name: "TaxReturnLongTermDebtSection",
  components: {TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <TaxReturnTableHeader/>
    </template>

    <template v-slot:body>
      <TaxReturnTableRow :description="$gettext('Schulden aan kredietinstellingen')"
                         :calculated-value="data.calculated.balance_passive_long_term_debt_credit"
                         v-model="data.edit.balance_passive_long_term_debt_credit"/>

      <TaxReturnTableRow :description="$gettext('Overige langlopende schulden')"
                         :calculated-value="data.calculated.balance_passive_long_term_debt_other"
                         v-model="data.edit.balance_passive_long_term_debt_other"/>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">
table {
  width: 100%;
}
</style>